export const GRADIENTS = {
  BLUE: ['#052E46', '#0575B7'],
  ORANGE: ['#F85501', '#F88801'],
  YELLOW: ['#F58B1B', '#F5C124'],
  PURPLE: ['#CB4CCC', '#7B3291'],
  GREEN: ['#39CC64', '#309D31']
}
